import { render, staticRenderFns } from "./view_rule.vue?vue&type=template&id=956a0742&scoped=true"
import script from "./view_rule.vue?vue&type=script&lang=js"
export * from "./view_rule.vue?vue&type=script&lang=js"
import style0 from "./view_rule.vue?vue&type=style&index=0&id=956a0742&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "956a0742",
  null
  
)

export default component.exports